import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { FormBuilder, Validators } from '@angular/forms';
import { ProjectNote } from '../../../entities/projectNote';
import { DashboardService } from '../../../services/dashboard.service';

@Component({
  selector: 'app-project-notes',
  templateUrl: './project-notes.component.html',
  styleUrls: ['./project-notes.component.scss'],
  standalone: false
})
export class ProjectNotesComponent implements OnInit {
  @Input() notes: ProjectNote[];
  @Input() projectId: string;
  @Input() isView: boolean;
  @ViewChild('buttons') buttons: ElementRef;
  appStrings: AppLocalization;
  dateTimeFormat: string;
  form: any;
  isAddNote = false;
  isScrolled = false;
  loading = false;

  constructor(
    fb: FormBuilder,
    private appInfoService: AppInfoService,
    private dashboardService: DashboardService
  ) {
    this.form = fb.group({
      note: ['', [Validators.required, Validators.maxLength(3000)]],
    });
  }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.dateTimeFormat = this.appInfoService.dateTimeFormat;
  }

  ngAfterViewChecked() {
    if (this.isAddNote && !this.isScrolled) {
      this.buttons.nativeElement.scrollIntoView({ behavior: 'smooth' });
      this.isScrolled = true;
    }
  }

  removeNote(index: number) {
    this.loading = true;
    const currentNote = this.notes[index];
    this.dashboardService.deleteProjectNote(currentNote.projectNoteId).subscribe(() => {
      this.loading = false;
      this.notes.splice(index, 1);
    });
  }

  toggleAddNote() {
    this.isAddNote = !this.isAddNote;
    this.isScrolled = false;
    this.form.reset();
  }

  addNewNote() {
    this.form.controls.note.markAsTouched();
    const { value, valid } = this.form;
    if (valid) {
      this.loading = true;
      this.dashboardService.addProjectNote(this.projectId, value.note).subscribe(result => {
        this.loading = false;
        this.isAddNote = !this.isAddNote;
        this.notes.push(
          {
            projectNoteId: result.projectNoteId,
            note: value.note,
            date: result.date,
            author: result.author,
          });
      });
    }
  }
}
